import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type SubdirectoryArrowRightProps = IconComponentBaseProps;

export const SubdirectoryArrowRight = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: SubdirectoryArrowRightProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_6156_50000"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6156_50000)">
        <path
          d="M8.98257 13.3052C8.87924 13.2017 8.82862 13.0836 8.83074 12.9507C8.83285 12.8178 8.88346 12.7017 8.98257 12.6025L11.0852 10.5H4.8724C4.53996 10.5 4.25596 10.3823 4.0204 10.1468C3.78496 9.91128 3.66724 9.62728 3.66724 9.29483V3.5C3.66724 3.35811 3.71513 3.23933 3.8109 3.14367C3.90657 3.04789 4.02535 3 4.16724 3C4.30913 3 4.4279 3.04789 4.52357 3.14367C4.61935 3.23933 4.66724 3.35811 4.66724 3.5V9.29483C4.66724 9.35472 4.68646 9.40389 4.7249 9.44233C4.76335 9.48078 4.81251 9.5 4.8724 9.5H11.0852L8.9724 7.38717C8.86896 7.28372 8.81896 7.16661 8.8224 7.03583C8.82585 6.90517 8.87585 6.78811 8.9724 6.68467C9.07585 6.58122 9.19401 6.52889 9.3269 6.52767C9.45979 6.52633 9.57579 6.57522 9.6749 6.67433L12.5787 9.57817C12.6412 9.64061 12.6852 9.70644 12.7107 9.77567C12.7364 9.84489 12.7492 9.91967 12.7492 10C12.7492 10.0803 12.7364 10.1551 12.7107 10.2243C12.6852 10.2936 12.6412 10.3594 12.5787 10.4218L9.6954 13.3052C9.59196 13.4085 9.47318 13.4602 9.33907 13.4602C9.20485 13.4602 9.08601 13.4085 8.98257 13.3052Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
